// @flow
import styled from "styled-components"
import { PageTitle } from "componentsStyled/Typography/Titles"

export const StyledTitle = styled(PageTitle)`
  padding: 0;
  font-size: 2.6rem;
`



// WEBPACK FOOTER //
// ./src/pages/Explore/styled.js